import React from 'react'
import { Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import { IMapMarkerProps } from './IMapMarkerProps'

const MapMarker = ({ lat, lng, popupTitle }) => {
  L.Icon.Default.imagePath =
    '//cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/'
  return (
    <Marker position={[lat, lng]}>
      {popupTitle && <Popup isOpen>{popupTitle}</Popup>}
    </Marker>
  )
}

MapMarker.defaultProps = {
  popupTitle: undefined,
}

MapMarker.propTypes = IMapMarkerProps

export { MapMarker }
